const hasNative = "scrollRestoration" in window.history;
const initial = hasNative ? window.history.scrollRestoration : "auto";
const data = { hasNative, initial };

function setScrollRestoration(scrollRestoration) {
  if (data.hasNative) {
    window.history.scrollRestoration = scrollRestoration;
  }
}
function resetScrollRestoration() {
  setScrollRestoration(data.initial);
}

var index = /*         */Object.freeze({
  __proto__: null,
  resetScrollRestoration: resetScrollRestoration,
  setScrollRestoration: setScrollRestoration
});

export { index as i, resetScrollRestoration as r, setScrollRestoration as s };
/*                                 */
